import { render, staticRenderFns } from "./FilteringModule.vue?vue&type=template&id=304a5126&"
import script from "./FilteringModule.vue?vue&type=script&lang=js&"
export * from "./FilteringModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports